/* eslint-disable better-mutation/no-mutation */

import { isServer } from 'tradera/utils/nextjs';
import { parseJwt } from 'tradera/apps/registration/helpers/parse-jwt';

if (isServer) {
    // Do not remove this without also removing the disable of eslint better-mutation/no-mutation at top of file.
    throw new Error(
        'This implementation is not compatible with SSR as global properties are shared between server instances'
    );
}

// these functions are available in the android/ios app code base
(function (w) {
    if (!w) {
        return;
    }
    let saved = null;
    let savedListener = null;
    w.onGoogleNativeLogin = (err, data) => {
        if (savedListener) {
            savedListener(err, data);
        } else {
            saved = { err: err, data: data };
        }
    };
    w.onGoogleNativeLoginSetListener = (listener) => {
        savedListener = listener;
        if (saved) {
            savedListener(saved.err, saved.data);
            saved = null;
        }
    };
})(window);

export default class GoogleLogin {
    constructor(googleAppId) {
        !googleAppId &&
            console.error('GoogleLogin.googleAppId is required but was empty');
        this.appId = googleAppId;
        this.email = null;
        this.firstName = null;
        this.lastName = null;
    }

    /**
     * indicate if the google auth lib is available in the web context
     */
    isLoaded() {
        return window.google ? true : false;
    }

    onNativeInitiatedLogin(callback) {
        if (!window) {
            return;
        }
        window.onGoogleNativeLoginSetListener((err, data) => {
            if (err) {
                console.error(
                    'Google Native Initiated login failed',
                    err,
                    data
                );
                this._save(null);
            } else {
                this._save(data);
                callback(data);
            }
        });
    }

    async login(options = { native: false }) {
        if (window && options.native) {
            return new Promise((resolve, reject) => {
                window.onGoogleNativeLoginSetListener((err, data) => {
                    if (err || !data) {
                        console.error('Google Native login failed', err, data);
                        this._save(null);
                        reject(err ? err : 'Aborted');
                    } else {
                        if (!data.userId) {
                            data.userId = parseJwt(data.accessToken)?.sub;
                        }
                        if (!data.lastName) {
                            data.lastName = parseJwt(
                                data.accessToken
                            )?.family_name;
                        }
                        this._save(data);
                        resolve(data);
                    }
                });
                window.document.location.href =
                    'tradera://register/google?callbackFunc=onGoogleNativeLogin';
            });
        } else {
            const response = parseJwt(options.providerData.credential);
            return {
                accessToken: options.providerData.credential,
                email: response.email,
                firstName: response.given_name,
                lastName: response.family_name,
                userId: response.sub
            };
        }
    }

    _save(data) {
        if (!data) {
            this.email = null;
            this.firstName = null;
            this.lastName = null;
        } else {
            this.email = data.email;
            this.firstName = data.firstName;
            this.lastName = data.lastName;
        }
    }
}
